/* global DPI_STATS_TMOUT_MS, views, globalNavigate */
import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import { expressTarget, getBqnIdCmdPart } from "common/api";
import { parseSubscribersSpeed } from "../api";
import * as d3 from "d3";
import { hoursScopeChoicesTwoWeeks } from "common/constants";
import View from "common/View";
import Help from "./Help";

const doSpeedShareRetrieval = ({
  target,
  hours = 72,
  categories = 20,
  directions = "all",
  output = "ip-addresses",
  mode,
  bqnId,
  interval = 10,
}) =>
  expressTarget(target).then((expressedTarget) =>
    ifCl.run(
      `show statistics subscribers top ${expressedTarget} ${output} direction ${directions} categories ${
        categories - 1
      } hours ${hours} interval ${interval}${getBqnIdCmdPart(mode, bqnId)}`,
      { timeout: DPI_STATS_TMOUT_MS },
    ),
  );

const retrieval = ({
  target,
  hours,
  categories,
  directions,
  output,
  mode,
  bqnId,
}) =>
  doSpeedShareRetrieval({
    target,
    hours,
    categories,
    directions,
    output,
    mode,
    bqnId,
  })
    .then(parseSubscribersSpeed)
    .catch((error) => console.error(error) || error);

const formatOnlyDecimals = d3.format(",.2f");

const formatDecimals = (value) =>
  value === undefined ? "--" : formatOnlyDecimals(value);

const TotalVolume = ({ totals }) => (
  <h4 className="align-left">
    Total volume: {formatDecimals(totals.volume)} GB
  </h4>
);

const lessThanAMonthOptions = ({ value }) => value < 24 * 30;

const settings = {
  hours: { options: hoursScopeChoicesTwoWeeks.filter(lessThanAMonthOptions) },
};

const enabled = {
  hours: true,
  directions: true,
  categories: true,
  target: true,
  output: true,
  filter: false,
};

const returnTo = "viewSubscribersHourlyVolume";

const openSubscriberDetail = ({ key }, { output = "ip-addresses" }) => {
  if (key === "REST") {
    return;
  }

  const target = output === "subscriber-ids" ? "subsId" : "addr";
  views.doKeep(returnTo);
  globalNavigate("viewSubsDetail", { returnView: returnTo, [target]: key });
};

const SubscribersHourlyVolume = () => {
  const actions = useContext(ActionsContext);
  return (
    <View
      title="Top subscribers by time"
      Help={Help}
      subtitle={
        <>
          <code>right-click</code>
          on the area for a subscriber inside the chart, or in the labels above
          the chart, to get detailed subscriber information
        </>
      }
    >
      <Report
        graphTitle={null}
        from="timeline"
        itemsFrom="subscribers"
        itemsValueFrom="speed"
        provider={retrieval}
        actions={actions}
        settings={settings}
        enabled={enabled}
        Totals={TotalVolume}
        onSeriesInspect={openSubscriberDetail}
      />
    </View>
  );
};

export default SubscribersHourlyVolume;
